import TextHandWritingController from './text';

/**
 * 日本語入力用のコントローラ。
 * TextHandWritingControllerから派生する。
 * 
 * [依存関係]
 * TextHandWritingController
 * 
 * @param {*} $scope 
 */
export default function($scope) {
  TextHandWritingController($scope);

  // 親がScopeにセットしたイベント処理を書き換える場合は退避する
  $scope.parentMouseDown = $scope.onMouseDown;
  $scope.parentMouseUp = $scope.onMouseUp;

  /**
   * onMouseDown: 入力エリアの既存のテキストを消去する
   */
  $scope.onMouseDown = function(e) {
    if ($scope.element.closest('.recognition-element.active').length > 0) {
      $scope.parentMouseDown(e);
      $scope.clearTextDisplay(e);
      $scope.newNextWritingBox(e);
    }
  }

  /**
   * onMouseUp: 新しい描画エリアを作る
   */
  $scope.onMouseUp = function(e) {
    $scope.parentMouseUp(e);
    // $scope.newNextWritingBox(e);
  }

  /**
   * 描画済みの文字を消去する
   */
  $scope.clearTextDisplay = function() {
    const $captureElement = $scope.element.closest('.recognition-box-inner');

    if ($captureElement.length) {
      $captureElement.parent().find('.box-answer')
      .removeClass('right-answer')
      .css('display', 'none');
    }
  }

  /**
   * 複数の描画ボックスが必要なDOMの場合は、隣に新らしい描画ボックスを生成する。
   */
  $scope.newNextWritingBox = function() {
    const $captureElement = $scope.element.closest('.recognition-box-inner');

    if ($captureElement.length) {
      // 次のボックスを探す
      const $next = $captureElement.closest('.recognition-element')
      .next('.recognition-element');

      // 対象外
      if (! $next.length) {
        return;
      }

      // 既に描画エリアを生成済みなら .active が付与されてるのでその場合は再作成不要
      if ($next.hasClass('active')) {
        return;
      }

      // 無効化されてる場合は、生成せずに有効化する
      if ($next.hasClass('disabled')) {
        $scope.enableNextWritingBox(true);
        return;
      }
      
      // dom 生成
      const $parent = $next.find('.recognition-box-inner');
      const $key = $next.get(0).id.match(/\d+\_\d+\_\d+$/);
      if ($key) {
        // 描画エリア作成
        const html = createCanvasBox($key[0]);
        createDynamicDirective(html, $parent);
        // スタイル付与
        $next.addClass('active')
      }
    }
  }

  /**
   * 隣に描画ボックスが生成されていれば無効化する。
   * @param {boolean} enabled 
   */
  $scope.enableNextWritingBox = function(enabled) {
    const $captureElement = $scope.element.closest('.recognition-box-inner');

    if ($captureElement.length) {
      // 次のボックスを探す
      const $next = $captureElement.closest('.recognition-element')
      .next('.recognition-element');

      // 対象外
      if (!$next.length) {
        return;
      }

      if (enabled) {
        // スタイル無効化
        $next.addClass('active');
        $next.removeClass('disabled');
      }
      else {
        // スタイル無効化
        $next.addClass('disabled');
        $next.removeClass('active');
      }
    }
  }

  /**
   * 描画済みテキストを消去し、隣の入力を無効にする。
   */
  $scope.undo = function() {
    $scope.clearTextDisplay();
    $scope.enableNextWritingBox(false);
  }

  /**
   * １文字消去の処理（print/controller.tegakiUndoから呼ばれる）
   * 消去対象のDOM配下ならUndo処理を呼ぶ。
   */
  $scope.addEventListener('undo', function(e,id) {
    if ($scope.element && $scope.element.closest(id).length) {
      $scope.undo();
    }
  });

  /**
   * 受信結果解析後の処理
   * @param {object} param event オブジェクトに以下の情報を加えたデータ
   * @param {string} param.printId DOMのIDから抽出したプリントID。既存処理に必要。
   * @param {string} param.exportedChar exports[text/plain] の文字
   * @param {object} param.exportedJiix 認識結果
   */
  $scope.afterExported = function(param) {
    // 日本語入力は複数候補を渡す。
    const candidates = $scope.exportCandidates(param);
    selectDrawingAnswer(param.printId, candidates, RECOGNITION.language_jp);
  }

  /**
   * 認識結果候補に大文字小文字判定を加える。
   * @param {object} param afterExported の引数と同じ 
   */
  $scope.exportCandidates = function(param) {
    // 筆跡大きさから小文字変換
    const strokeW = $scope.drawing.strokeMax.x - $scope.drawing.strokeMin.x;
    const strokeH = $scope.drawing.strokeMax.y - $scope.drawing.strokeMin.y;
    const lowerBoxW = param.target.clientWidth * 0.55;
    const lowerBoxH = param.target.clientHeight * 0.55;
    // console.log(['boxWH,strokeWH',lowerBoxW, lowerBoxH, strokeW, strokeH].join(', '))

    // 日本語の場合は1文字入力のみなので、2文字以上の判定は削除する
    const candidates = param.exportedJiix.words[0].candidates.filter(c => c.length < 2);

    if (lowerBoxW > strokeW && lowerBoxH > strokeH && (
      (!verticalKanji && drawingTextSide == CANVAS_CORNER.LEFT_BOTTOM) ||
      (verticalKanji && drawingTextSide == CANVAS_CORNER.RIGHT_TOP)
    )) {
      // console.log('>>>>>>>>>>>>>>>> 小文字鑑定')
      // 小文字対象外なら候補から外す
      const newCandidates = [];
      for (const char of candidates) {
        // 小文字のはずが大文字で認識されてる場合、変換する
        const p = JAPANESE_UPPER.indexOf(char);
        if (p > -1) {
          // console.log(char + ' -> ' + JAPANESE_VOWEL[p])
          newCandidates.push(JAPANESE_VOWEL[p])
        }
        // 小文字で認識された場合そのまま
        else if (JAPANESE_VOWEL.indexOf(char) > -1) {
          newCandidates.push(char);
        }
      }
      // console.log(newCandidates)
      if (newCandidates.length) {
        return newCandidates;
      }
      // 小文字対象外の場合は真ん中に表示させる。
      else {
        drawingTextSide = "";
      }
    }

    return candidates
  }

  /**
   * 描画エリアを４分割した場合の幅や高さの情報を返却する。
   * 日本語はマスが小さいので大きめな範囲をとる。
   * 
   * @param {element} targetElement HTML要素
   * @returns {object} as { largeW, largeH, smallW, smallH }
   */
  $scope.getWritingAreaInfo = function(targetElement) {
    return {
      // 大きめに４分割した場合の幅と高さ
      largeW: targetElement.clientWidth * 0.65,
      largeH: targetElement.clientHeight * 0.65,
      // 小さめに４分割した場合の幅と高さ
      smallW: targetElement.clientWidth * 0.35,
      smallH: targetElement.clientHeight * 0.35,
    }
  }
}